import http from "../../http";

const login = {
    getUserInfo() {
        return http.get("/gateway/api/oauth/UserInfo")
    },
    selectStaffPermissions(param) {
        return http.get("/gateway/api/auth/pc/permissions/selectStaffPermissions",param)
    },
    loginCompanyByOrgCode(orgCode) {
        return http.get("/gateway/api/sycompany/pc/company/loginCompanyByOrgCode?orgCode="+orgCode)
    },
    loginCompanyOperatorByOrgCode(orgCode) {
        return http.get("/gateway/api/sycompany/pc/operator/selectByOrgCode?orgCode="+orgCode)
    },
    loginAgentByOrgCode(orgCode) {
        return http.get("/gateway/api/sycompany/pc/CompanyAgentPC/loginByOrgCode?orgCode="+orgCode)
    },
    captchaImage() {
        return http.get("/gateway/api/lfuser/captcha/captchaImage")
    },
    getCaptchaAppletQr(oemCode, orgCode) {
        let url = "/gateway/api/lfuser/captcha/getCaptchaAppletQr?oemCode=" + encodeURIComponent(oemCode || "")
        if (orgCode) {
            url += "&orgCode=" + encodeURIComponent(orgCode)
        }
        return http.get(url)
    },
    weappCodeLoginResult(oemCode, code) {
        return http.get("/gateway/api/lfuser/weappLogin/weappCodeLoginResult?oemCode="+oemCode+"&code="+code)
    },
    logout() {
        return http.get("/gateway/api/oauth/Logout")
    },
    

    
}
export default login
